module.exports = __webpack_public_path__ + "static/media/fetal-pillow@3x.85778d56.png";